export function downloadFile(url: string, filename?: string) {
  const link = document.createElement('a');
  link.style.display = 'none';
  link.setAttribute('download', filename ?? 'download');
  link.setAttribute('href', url);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function downloadWithIframe(url: string) {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.setAttribute('src', url);

  document.body.appendChild(iframe);

  setTimeout(() => {
    document.body.removeChild(iframe);
  }, 5000);
}
